import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

function ProtectedRoute({children}) {
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
    useEffect(() =>{
    const userId = localStorage.getItem("taxUserId");
    const token = localStorage.getItem("taxToken");
    const expiryTime = localStorage.getItem("taxExpiryTime");
    const taxRestUrl = localStorage.getItem("taxRestUrl");
    const currentTime = new Date().getTime();
    if(!userId && !token) {
        navigate("/login")
        sessionStorage.setItem("taxSessionExpired", "false");
        setShowPopup(false);
        return;
    }
    if (expiryTime && currentTime > Number(expiryTime)) {
        localStorage.clear();
        sessionStorage.setItem("taxSessionExpired", "true");
        setShowPopup(true);
    }
    },[navigate]);

    const handleOk = () => {
        sessionStorage.setItem("taxSessionExpired", "false");
        setShowPopup(false);
        navigate("/login")
    } 
    return (
        <>
        <Dialog header="Session Expired" visible={showPopup} baseZIndex={99999} closable={false} modal style={{width: '25rem'}}>
          <p>Your session has expired. Please login again.</p>
          <div className='flex justify-content-end mt-4'>
            <Button label="OK" onClick={handleOk}/>
          </div>
         </Dialog>
         {!showPopup && children}
        </>
        );
}

export default ProtectedRoute;